import benefitsAdmin from './benefits-admin';
import expansion from './expansion';
import timeTracking from './time-tracking';
import upsell from './upsell';

export default { benefitsAdmin, expansion, timeTracking, upsell };
